module.exports = __webpack_public_path__ + "img/rank3.db5dbd27.png";